<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-08 09:18:07
-->
<template>
  <div>
    <div class="maintitle">{{name}}自评</div>
    <el-divider></el-divider>
    <el-table :data="alist" row-key="id" border>
      <el-table-column prop="title" width='80' label="考核项"></el-table-column>
      <el-table-column label="考核标准">
        <template slot-scope='scope'>
          <span v-html='scope.row.standard'></span>
        </template>
      </el-table-column>
      <el-table-column label="评分要点" v-if='hasscore==1'>
        <template slot-scope='scope'>
          <span v-html='scope.row.points'></span>
        </template>
      </el-table-column>
      <el-table-column prop="proportion" label="所占比重" width='80' align="center" v-if='hasscore==1'></el-table-column>
      <el-table-column label="自评得分" align="center" width='100' v-if='hasscore==1'>
        <template slot-scope="scope">
          <span v-if='scope.row.id==0'>{{scope.row.score}}</span>
          <el-input v-model='scope.row.score' v-else></el-input>
        </template>
      </el-table-column>
      <el-table-column label="自评" align="center">
        <template slot-scope="scope">
          <el-input type='textarea' v-model='scope.row.beizhu' v-if="scope.row.id!=0"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <table class="excellent-table">
      <tr>
        <th style='width:500px;'>优秀标准</th>
        <th>自评理由</th>
      </tr>
      <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
        <td v-html="item.standard" class="text-left"></td>
        <td>
          <span v-if='item.id==0'>{{item.beizhu}}</span>
          <el-input type='textarea' v-model='item.beizhu' v-else></el-input>
        </td>
      </tr>
      <tr>
        <td>结果</td>
        <td>
          <el-select size="mini" v-model="assessinfo.detail[0].excellent">
            <el-option label='不评' :value='0'></el-option>
            <el-option v-for="(item,index) in excellentTypeList" :key='index' :label='item.excellent_title' :value="item.excellent_id"></el-option>
          </el-select>
        </td>
      </tr>
    </table>
    <!-- <table class="excellent-table">
      <tr>
        <td style="width:80px;">自评</td>
        <td class="excellent">
          <el-select size="mini" v-model="assessinfo.selfexcellent">
            <el-option label='不评' :value='0'></el-option>
            <el-option v-for="(item,index) in excellentTypeList" :key='index' :label='item.excellent_title' :value="item.excellent_id"></el-option>
          </el-select>
        </td>
        <td>
          <el-input type='textarea' v-model="assessinfo.selfbeizhu"></el-input>
        </td>
      </tr>
    </table> -->
    <div>
      <el-button @click="submdfy(1)" size='mini' type='info'>暂存</el-button>
      <el-button @click="submdfy(2)" size='mini' type="success">提交</el-button>
      <el-button @click="$router.go(-1)" size='mini'>返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //模板列表
      assessinfo: {},
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      hasscore: 0,
      name: '',
      excellentlist: []
    };
  },
  computed: {
    score() {
      // if(this.hasscore==0) return [];
      let temp = [];
      for (let i in this.list) {
        if (this.list[i].id != 0)
          temp.push({
            did: this.list[i].did,
            tiid: parseInt(this.list[i].id),
            proportion: this.list[i].proportion,
            score: this.list[i]['score'] ? parseFloat(this.list[i]['score']) : 0,
            beizhu: this.list[i]['beizhu'] ? this.list[i][['beizhu']] : '',
          })
      }
      return temp;
    },
    alist() {
      if (this.hasscore == 0) return this.list;
      let temp = {
        id: 0,
        title: '合计',
        score: 0
      }
      for (let item in this.list) {
        temp.score += isNaN(parseFloat(this.list[item].score)) ? 0 : parseFloat(this.list[item].score);
      }
      temp.score = this.assessinfo.detail[0].score = parseInt(temp.score * 100) / 100;
      // return this.list;
      return this.list.concat(temp);
    },
  },
  methods: {
    getAssessment() {
      let id = this.$route.params.id;
      if (!id) {
        this.$router.go(-1);
      }
      this.$axios({
        url: this.HOST + "/kaohe/selfass/getDepAss",
        method: "post",
        data: {
          id: id,
        },
      }).then((res) => {
        this.list = res.data.list;
        this.assessinfo = res.data.assinfo;
        this.hasscore = res.data.hasscore;
        this.name = res.data.depname
        this.excellentlist = res.data.excellentlist;
      });
    },
    submdfy(status) {
      this.$axios({
        url: this.HOST + "/kaohe/selfass/saveDepAss",
        method: "post",
        data: {
          info: this.assessinfo,
          score: this.score,
          status: status,
          excellent: this.excellentlist
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.$message({
            type: 'success',
            message: res.data.info
          })
          if (status == 2) {
            this.$router.go(-1);
          } else {
            this.getAssessment();
          }
        }
      });
    },
  },
  created: function () {
    this.getAssessment();
  },
};
</script>